<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M33.86 64.87c.383-.3.575-.717.575-1.252 0-.534-.188-.947-.563-1.239-.375-.291-.888-.437-1.54-.437h-2.91v3.377h2.91c.636 0 1.145-.15 1.528-.45"
      />
      <path
        d="M46.463 70.398c.929.875 2.061 1.312 3.398 1.312 1.14 0 2.045-.267 2.713-.802v-5.564H57V72.9c-.685.745-1.671 1.384-2.959 1.92-1.32.517-2.713.777-4.18.777-2.64 0-4.857-.827-6.65-2.479-1.776-1.668-2.665-3.79-2.665-6.366 0-2.592.897-4.714 2.69-6.366 1.776-1.652 4.041-2.479 6.796-2.479 1.776 0 3.439.405 4.987 1.215v4.107c-1.58-.859-3.137-1.288-4.67-1.288-1.548 0-2.82.454-3.813 1.36-.978.908-1.467 2.082-1.467 3.524 0 1.506.465 2.697 1.394 3.572zm-21.44 4.86v-17.01h7.627c1.923 0 3.439.495 4.547 1.483 1.125.988 1.687 2.268 1.687 3.839 0 1.571-.562 2.86-1.687 3.863-1.108.989-2.624 1.483-4.547 1.483h-3.227v6.341h-4.4zm46.184 18.224H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zM11.43 70.446c.994.746 2.078 1.118 3.251 1.118.994 0 1.724-.219 2.188-.656.465-.437.697-1.158.697-2.162V58.249h4.4V69.45c0 2.317-.66 3.953-1.98 4.908-1.173.827-2.624 1.24-4.351 1.24-1.842 0-3.244-.316-4.205-.948v-4.204zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M45.777 28.58a2.406 2.406 0 0 0-1.871.69l-3.094 3.099-7.889-7.842a2.406 2.406 0 0 0-1.703-.715 2.404 2.404 0 0 0-1.726.859l-11.99 14.3a2.373 2.373 0 0 0 .303 3.357c.4.333.9.527 1.423.552h33.573a2.39 2.39 0 0 0 2.398-2.384c0-.515-.169-1.017-.48-1.43l-7.194-9.533a2.401 2.401 0 0 0-1.75-.954M43.21 14.279c2.65 0 4.797 2.134 4.797 4.767 0 2.632-2.148 4.766-4.796 4.766-2.65 0-4.796-2.134-4.796-4.766 0-2.633 2.147-4.767 4.796-4.767"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-jpg',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
